// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { TenementExchangeModel } from "src/app/model/TenementExchangeModel";

@Component({
  selector: "app-secure-tenement-exchange-list",
  templateUrl: "./tenement-exchange-list.component.html",
  styleUrls: ["./tenement-exchange-list.component.scss"],
})
export class TenementExchangeListComponent implements OnInit {
  page: Page<TenementExchangeModel>;
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  // dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  dataSourceLottery: MatTableDataSource<TenementExchangeModel> =
    new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "applicantName",
    "panNumber",
    "scheme",
    // "buildingNo",
    "wing",
    // "flatNo",
    // "floor",
    "action",
  ];

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });
    this.filterForm.controls["filterText"].setValue(null);

    // this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchTenementList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page) => {
          this.page = page;
          this.dataSourceLottery = new MatTableDataSource(page.content);
          console.log(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
            console.log(this.paginator.pageIndex);
            console.log(this.paginator.length);
          });
          this.isSearchDisabled = false;
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      console.log("onSearch");
      console.log(this.filterForm.valid);
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Lottery",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  editTenement(applicationKey: number, schemeId: number, lotteryId: number) {
    this.router.navigate([
      "/secure",
      "tenement-exchange",
      "form",
      applicationKey,
      schemeId,
      lotteryId,
    ]);
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
